import React, {useEffect, useRef, useState} from 'react';
import sButtons from '../../../assets/styles/buttons.module.css';
import styles from './HeaderButtons.module.css';
import {KBModal} from "../KBModal/KBModal";
import {Role} from "../../../services/models/role";
import {IFolder} from "../../../types/knowledgeBase.types";

interface HeaderButtonsProps {
    isRootLevel: boolean;
    isAdmin: boolean;
    folderId?: string;
    roles: Role[];
    currentFolder?: IFolder;
    folders?: IFolder[];
}

export const HeaderButtons: React.FC<HeaderButtonsProps> = ({
                                                                isRootLevel,
                                                                isAdmin,
                                                                folderId,
                                                                roles,
                                                                currentFolder,
                                                                folders = []
                                                            }) => {
    const [modalMode, setModalMode] = useState<'createFolder' | 'editFolder' | 'uploadFile' | 'uploadVideo' | null>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!isAdmin) return null;

    const handleClose = () => setModalMode(null);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleMenuItemClick = (mode: 'createFolder' | 'uploadFile' | 'uploadVideo') => {
        setDropdownOpen(false);
        setModalMode(mode);
    };

    return (
        <>
            {modalMode && (
                <KBModal
                    show={true}
                    onHide={handleClose}
                    roles={roles}
                    mode={modalMode}
                    currentFolder={currentFolder}
                />
            )}

            <div className={styles.container}>


                <div className={styles.buttonsContainer}>
                    {isRootLevel ? (
                        <button
                            className={`${sButtons.iconButton} ${sButtons.addButton}`}
                            onClick={() => setModalMode('createFolder')}
                        >
                            Добавить папку
                        </button>
                    ) : (
                        <>
                            <div className={styles.dropdownContainer} ref={dropdownRef}>
                                <button
                                    className={`${sButtons.iconButton} ${sButtons.addButton}`}
                                    onClick={toggleDropdown}
                                >
                                    Добавить
                                </button>
                                {dropdownOpen && (
                                    <div className={styles.dropdownMenu}>
                                        <div
                                            className={`${styles.dropdownItem} ${styles.folderIcon}`}
                                            onClick={() => handleMenuItemClick('createFolder')}
                                        >
                                            Добавить папку
                                        </div>
                                        <div
                                            className={`${styles.dropdownItem} ${styles.fileIcon}`}
                                            onClick={() => handleMenuItemClick('uploadFile')}
                                        >
                                            Добавить файл
                                        </div>
                                        <div
                                            className={`${styles.dropdownItem} ${styles.videoIcon}`}
                                            onClick={() => handleMenuItemClick('uploadVideo')}
                                        >
                                            Добавить видео файл
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button
                                className={`${sButtons.iconButton} ${sButtons.settingsButton} ${sButtons.lightBlueButton}`}
                                onClick={() => setModalMode('editFolder')}
                            >
                                Редактировать папку
                            </button>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
